import React from 'react';
import { images } from '../../constants';
import RegisterForm from '../../elements/RegisterForm';

function RegisterPage() {
  return (
    <div className='flex flex-col lg:flex-row  min-h-screen relative overflow-auto'>
        <div className='flex w-full lg:w-1/2 flex-col items-center'>
            <div className="absolute bottom-0 left-0">
                <div className='flex justify-center mb-[.5cm]'>
                    <img
                        src={images.senarai}
                        alt="senarai"
                        style={{ width: "230px", height: "45px" }}
                    />
                </div>
                <img
                    src={images.register}
                    alt="register"
                />
            </div>
        </div>
        <RegisterForm />
    </div>
  );
}

export default RegisterPage;
